module.exports = __webpack_public_path__ + "static/media/videos.7343bcac.svg";